import { render, staticRenderFns } from "./SupportHub.vue?vue&type=template&id=2534ea0c&scoped=true&"
import script from "./SupportHub.vue?vue&type=script&lang=js&"
export * from "./SupportHub.vue?vue&type=script&lang=js&"
import style0 from "./SupportHub.vue?vue&type=style&index=0&id=2534ea0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2534ea0c",
  null
  
)

export default component.exports